import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { EN_US } from 'shared/i18n';
import withTheme from 'theme/withTheme';
import { TRACK_SEARCH_BY_ZIP } from 'utils/dataLayer';
import { pushRoute } from '../../../../modules/routing';
import Translation from '../../../../website/components/stateless/Translation';
import styles from './SMInputSearch.scss';

const propTypes = {
  intl: intlShape.isRequired,
  locale: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  pageType: PropTypes.string,
  theme: PropTypes.shape({
    fonts: PropTypes.shape({
      primary: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  widgetId: PropTypes.string,
};

const defaultProps = {};

class SMInputSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  updateSearch = e => this.setState({ search: e.target.value });

  handleKeyUp = (e) => {
    if (e.keyCode === 13) this.handleSearch();
  }

  handleSearch = () => {
    const { search } = this.state;

    if (!search) return;

    const { locale, pathname } = this.props;

    const isUS = locale === EN_US;
    const intlPrefix = pathname === `${locale}/search` ? '/search' : `/${locale}/search`;
    const route = `${isUS ? '/search' : `${intlPrefix}`}?query=${search}`;

    pushRoute(route);
  };

  render = () => {
    const { search } = this.state;
    const {
      placeholder = this.props.intl.formatMessage({
        id: 'widgets.searchgeo.inputplaceholder', defaultMessage: 'Search by Zip/Postal/City',
      }),
      widgetId,
    } = this.props;

    const inputProps = {
      type: 'search',
      className: 'fs-unmask w-full h-full px-3 py-1 rounded-l border-0 border-r-0',
      placeholder,
      onChange: this.updateSearch,
      value: search,
      onKeyUp: this.handleKeyUp,
      id: `enterprise.searchGeo.${widgetId}`,
      required: true,
      ariaLabel: placeholder,
    };

    return (
      <div className={`flex mb-2 w-full max-w-lg ${styles.searchBar}`}>
        <div
          className="
          flex
          h-10
          relative m-0
          flex-auto
          rounded-l
          border border-r-0 border-solid border-border bg-white font-normal focus:z-10 focus:border-primary"
        >
          <input {...inputProps} />
        </div>
        <Translation id="widgets.enterprise.searchButton" defaultMessage="Search">
          {text => (
            <button
              aria-label={text}
              onClick={this.handleSearch}
              {...TRACK_SEARCH_BY_ZIP}
              className="
              flex items-center rounded-r bg-sm-btn-prim px-6 py-2.5 leading-tight hovcusact:bg-sm-btn-prim-hov"
              type="button"
            >
              <i className="fa fa-fw fa-search" aria-hidden="true" />
            </button>
          )}
        </Translation>
      </div>
    );
  }
}

SMInputSearch.propTypes = propTypes;
SMInputSearch.defaultProps = defaultProps;

export default withTheme(injectIntl(SMInputSearch));
